import axios from 'axios'

export function initAxiosRequestInterceptor({ router, $q }) {
  axios.interceptors.response.use(
    // Request success
    (response) => {
      if (response.data.redirect) {
        if (response.data.redirect === router.currentRoute.value.path) {
          window.location.reload()
        } else {
          router.push(response.data.redirect)
        }
      }

      return response
    },
    // Request error
    (error) => {
      if (error.response?.status === 500) {
        $q.notify({
          position: 'top-right',
          message:
            "Une erreur est survenue. Si le problème persiste, veuillez contacter l'assistance.",
          color: 'negative',
          icon: 'error',
        })
      } else if ([403, 404].includes(error.response?.status) && error.response?.data?.redirect) {
        router.push(error.response.data.redirect)
      }

      return Promise.reject(error)
    },
  )
}
